module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/light/long-left-ccbb0f4b3ae7dc1c22926664312a1972.png";